import type { BusinessEntitlementConfig } from "@shared/types/localTypes/entitlements";
import dataTransfer from "@shared/statics/entitlement/dataTransfer.ts";
import storage from "@shared/statics/entitlement/storage.ts";
import consumption from "@shared/statics/entitlement/consumption.ts";
import archiveConsumption from "@shared/statics/entitlement/archive-consumption.ts";
import jfrt from "@shared/statics/entitlement/jfrt.ts";
import jfxr from "@shared/statics/entitlement/jfxr.ts";
import edge from "@shared/statics/entitlement/edge.ts";
import ePlusInstances from "@shared/statics/entitlement/ePlusInstances.ts";
import mothership from "@shared/statics/entitlement/mothership.ts";
import pipelines from "@shared/statics/entitlement/pipelines.ts";
import projects from "@shared/statics/entitlement/projects.ts";
import pdn from "@shared/statics/entitlement/pdn.ts";
import scans from "@shared/statics/entitlement/scans.ts";
import curation from "@shared/statics/entitlement/curation.ts";
import coldStorage from "@shared/statics/entitlement/coldStorage.ts";
import coldStorageUpload from "@shared/statics/entitlement/coldStorageUpload.ts";
import buildMinutes from "@shared/statics/entitlement/buildMinutes.ts";
import securityAdvanced from "@shared/statics/entitlement/securityAdvanced.ts";
import advancedSecurityUsers from "@shared/statics/entitlement/advancedSecurityUsers.ts";
import customerUxCode from "@shared/statics/entitlement/customerUxCode.ts";

export const entitlementsConfig: BusinessEntitlementConfig[] = [
  dataTransfer,
  storage,
  consumption,
  archiveConsumption,
  jfrt,
  jfxr,
  edge,
  ePlusInstances,
  mothership,
  pipelines,
  projects,
  pdn,
  scans,
  advancedSecurityUsers,
  curation,
  coldStorage,
  coldStorageUpload,
  buildMinutes,
  securityAdvanced,
  customerUxCode,
];
